import style from './Chat.module.css'
import Icon from '../../../assets/svgs/Icon'
import { useEffect, useState } from 'react'
import UploadModal from '../files/UploadModal'
import ChatInteface from './ChatInterface'
import ChatInput from './ChatInput'
import useDraggable from '../../../hooks/useDraggable'
import { useFilesContext } from '../../../contexts/FilesContext'
import DropZoneIcon from '../../../assets/svgs/DropIcon'
import { useHistoryContext } from '../../../contexts/HistoryContext'
import { logEvent } from '../../../utils/logEvent'
import FetchData from '../../../utils/FetchData'

const ChatBig = () => {
  const [openUpload, setOpenUpload] = useState(false)
  const [formData, setFormData] = useState({ message: '' })
  const [loading, setLoading] = useState(false)
  const [feedFaq, setFeedFaq] = useState([])
  const [errorMessage, setErrorMessage] = useState('')

  const { addRequest, addResponse, history, updateLastResponse, persistLastResponse } =
    useHistoryContext()
  const { draggable, onDragStart, onDragEnd, isDragging } = useDraggable()
  const { addFile, files, setFiles } = useFilesContext()

  useEffect(() => {
    const fetchFeedFaq = async (categories) => {
      const data = await FetchData.feedFaq(categories)

      setFeedFaq(data)
    }

    const fileCategories = [...new Set(files.map((file) => file.category))]


    fetchFeedFaq(fileCategories)
  }, [files])

  const handleDrop = (e) => {
    e.preventDefault()
    const data = e.dataTransfer.getData('application/json')
    const item = JSON.parse(data)
    addFile(item)

    logEvent({
      action: `drag_${item.category}`,
      content: item.title,
    })
  }

  const handleDragOver = (e) => {
    e.preventDefault()
  }

  const handleResponses = async (message) => {
    if (!message) {
      setErrorMessage('Oops! Looks like you forgot to type your message')
      return
    }

    setErrorMessage('')
    setLoading(true)
    addRequest(message)

    const filesUrls = files.map((file) => file.url)
    setFiles([])

    try {
      const chatUrl = `${process.env.REACT_APP_API_URL || ''}/chats/stream`
      const response = await fetch(chatUrl, {
        method: 'POST',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ message, urls: filesUrls }),
      })

      if (!response.ok || !response.body) throw new Error('Stream failed')

      const reader = response.body.getReader()
      const decoder = new TextDecoder('utf-8')

      let buffer = ''
      let fullText = ''

      setLoading(false)
      addResponse('', undefined, { persist: false })

      while (true) {
        const { value, done } = await reader.read()
        if (done) break

        buffer += decoder.decode(value, { stream: true })
        const lines = buffer.split('\n')
        buffer = lines.pop()

        for (const line of lines) {
          if (line.startsWith('data: ')) {
            try {
              const json = JSON.parse(line.slice(6).trim())
              if (json.content) {
                fullText += json.content
                updateLastResponse(fullText)
              }
            } catch (err) { }
          }
        }
      }
      persistLastResponse()
    } catch (error) {
      console.error('Error streaming response:', error)
      setLoading(false)
      persistLastResponse()
    }
  }

  return (
    <>
      {history.length > 0 ? (
        <ChatInteface
          smallInterface={false}
          history={history}
          loading={loading}
          handleResponses={handleResponses}
          setOpenUpload={setOpenUpload}
          openUpload={openUpload}
        />
      ) : (
        <div
          className={style.bigContainer}
          onDrop={handleDrop}
          onDragOver={handleDragOver}
        >
          {!isDragging ? (
            <>
              {' '}
              <div className={style.contentContainer}>
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                    gap: '20px',
                  }}
                >
                  <div className={style.icon}>
                    <Icon height={'60px'} width={'60px'} color={'#432C5B'} />
                  </div>{' '}
                  <div>
                    <p className={style.contentTitle}>Welcome back User! 👋</p>
                    <p className={style.contentSubTitle}>
                      Here are some suggestions for you to get the ball rolling
                      with me:
                    </p>
                  </div>{' '}
                  <div className={style.cardContainer}>
                    {feedFaq.map((faq, index) => (
                      <div
                        className={style.card}
                        key={index}
                        onClick={() => handleResponses(faq.question)}
                      >
                        <p className={style.cardTitle}>{faq.question}</p>
                      </div>
                    ))}
                  </div>
                </div>
                <div className={style.bigInput}>
                  <ChatInput
                    setOpenUpload={setOpenUpload}
                    openUpload={openUpload}
                    handleResponses={handleResponses}
                    setFormData={setFormData}
                    formData={formData}
                    errorMessage={errorMessage}
                    setErrorMessage={setErrorMessage}
                  />
                </div>{' '}
              </div>
            </>
          ) : (
            <>
              <div className={style.dropZone}>
                <DropZoneIcon />
                <p className={style.dropZoneText}>
                  Drag & drop items from dashboard to discuss with Chimp
                </p>
              </div>
            </>
          )}
        </div>
      )}
      {openUpload && (
        <UploadModal openUpload={openUpload} setOpenUpload={setOpenUpload} />
      )}
    </>
  )
}
export default ChatBig
